import type { BreadcrumbItem } from "@/lib/storyblok/api";
import { generateBreadcrumbListSchema } from "./generators";

export interface BreadcrumbListSchemaProps {
  items: BreadcrumbItem[];
}

export function BreadcrumbListSchema({ items }: BreadcrumbListSchemaProps) {
  if (items.length < 2) {
    return null;
  }

  const baseUrl = process.env.NEXT_PUBLIC_DOMAIN || "";

  const schema = generateBreadcrumbListSchema({
    items,
    baseUrl,
  });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema, null, 0),
      }}
    />
  );
}
